import React, { useEffect, useState } from "react";

import moment from "moment";

import * as MarketReducer from "containers/CommunityMarket/MarketReducer";
import { USE_CASE_OPTIONS, generateId } from "containers/CommunityMarket/MarketReducer";
import * as loginReducer from "containers/Login/reducer";
import * as adminReducer from "containers/Admin/reducer";

import { LineInput } from "components/Inputs/LineInput";
import Select from "react-select";

import { useDispatch, useSelector } from "types/store";

import { Button } from "aible";

import styles from "./style.module.css";
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from "@/aible/Dialog/Dialog";

const PublishModal = () => {
  const dispatch = useDispatch();

  const showPublishModal = useSelector((state) => MarketReducer.getShowPublishModal(state));
  const updateShowPublishModal = (bool) => dispatch(MarketReducer.updateShowPublishModal(bool));

  const publishItem = useSelector((state) => MarketReducer.getPublishItem(state));
  const updatePublishItem = (obj) => dispatch(MarketReducer.updatePublishItem(obj));

  const publishModel = (model) => dispatch(MarketReducer.publishModel(model));

  const useCaseOptions = USE_CASE_OPTIONS;

  const [itemName, updateItemName] = useState(publishItem?.name);
  const [itemUseCase, updateItemUseCase] = useState(useCaseOptions[0]);
  const [itemSummary, updateItemSummary] = useState(undefined);
  const [itemDetails, updateItemDetails] = useState(undefined);
  const [itemPrice, updateItemPrice] = useState(undefined);
  const [isLoading, updateIsLoading] = useState(false);

  const resetFields = () => {
    updateItemName(undefined);
    updateItemUseCase(useCaseOptions[0]);
    updateItemSummary(undefined);
    updateItemDetails(undefined);
    updateItemPrice(undefined);
  };

  useEffect(() => {
    resetFields();
  }, [showPublishModal]);

  const disablePublish = !(itemName?.length > 0 && itemPrice >= 0 && publishItem);

  const userID = useSelector((state) => loginReducer.getUserID(state));
  const users = useSelector((state) => adminReducer.getUsers(state));
  const currentUser = users.find((u) => u?.id === userID);

  return (
    <Dialog
      open={showPublishModal}
      onOpenChange={() => {
        updateShowPublishModal(false);
        updatePublishItem(undefined);
      }}
    >
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{`Publish ${publishItem?.name} to Marketplace`}</DialogTitle>
        </DialogHeader>
        <div className={styles.publishModalBody}>
          <div className={styles.publishModalRow}>
            <div className={styles.publishModalLabel}>{"Use Case Category"}</div>
            <div className={styles.publishModalInput}>
              <Select
                options={useCaseOptions}
                value={itemUseCase}
                onChange={(val) => updateItemUseCase(val)}
                placeholder={"Select a use case for your item"}
                menuPlacement={"bottom"}
              />
            </div>
          </div>
          <div className={styles.publishModalRow}>
            <div className={styles.publishModalLabel}>{"Item Name"}</div>
            <div className={styles.publishModalInput}>
              <LineInput
                value={itemName}
                onChange={(val) => updateItemName(val)}
                style={{ width: "100%" }}
                updateInstant={true}
                placeholder={"Please enter a name for your new marketplace listing"}
              />
            </div>
          </div>
          <div className={styles.publishModalRow}>
            <div className={styles.publishModalLabel}>{"Item Summary"}</div>
            <div className={styles.publishModalInput}>
              <textarea
                className={styles.publishTextArea}
                value={itemSummary}
                onChange={(e) => updateItemSummary(e.target.value)}
                placeholder={"Add a summary for your new marketplace listing"}
              />
            </div>
          </div>
          <div className={styles.publishModalRow}>
            <div className={styles.publishModalLabel}>{"Item Details"}</div>
            <div className={styles.publishModalInput}>
              <textarea
                className={styles.publishTextArea}
                value={itemDetails}
                onChange={(e) => updateItemDetails(e.target.value)}
                placeholder={"Add details for your new marketplace listing"}
              />
            </div>
          </div>
          <div className={styles.publishModalRow}>
            <div className={styles.publishModalLabel}>{"Item Price"}</div>
            <div className={styles.publishModalInput}>
              <LineInput
                value={itemPrice}
                onChange={(val) => updateItemPrice(Number(val))}
                style={{ width: "100%" }}
                updateInstant={true}
                placeholder={"Enter a price for your listing"}
              />
            </div>
          </div>
        </div>
        <DialogFooter>
          <Button
            onClick={() => {
              updateShowPublishModal(false);
              updatePublishItem(undefined);
            }}
          >
            {"Cancel"}
          </Button>
          <Button
            onClick={() => {
              const currentTime = moment().format();
              const newId = generateId();

              let retItem = {
                name: itemName,
                id: newId,
                price: itemPrice,
                created_date: currentTime,
                created_by: {
                  fullname: currentUser?.fullname,
                  id: userID
                },
                metadata: {
                  use_case: itemUseCase?.value,
                  summary: itemSummary,
                  details: itemDetails,
                  downloads: 0,
                  like_count: 0,
                  dislike_count: 0
                },
                source: publishItem
              };

              updateIsLoading(true);

              if (publishItem?.type === "FINE_TUNED_MODEL") {
                retItem.metadata = {
                  ...retItem.metadata,
                  base_model: publishItem?.metadata?.base_model_id
                };
                retItem.type = "FINE_TUNED_MODEL";

                return publishModel(retItem).then(() => {
                  updateIsLoading(false);
                  updateShowPublishModal(false);
                });
              }
            }}
            type="primary"
            disabled={disablePublish}
            isLoading={isLoading}
          >
            {"Publish to Marketplace"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default PublishModal;
